import { createAction } from '../../../store.model';
import { ActionType } from '../focus-selector.action';
import { Column } from '../grid/experimental.grid';

export interface FocusSelectorSortActiveForTeamGrid {
    column: Column;
}

export const focusSelectorSortActiveForTeamGrid = createAction<
    ActionType,
    FocusSelectorSortActiveForTeamGrid
>(ActionType.COACHING_FOCUS_SELECTOR__SORT_ACTIVE_FOR_TEAM_GRID);
